import React from 'react'
import '../mutualfunds/Mutual.css'
import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
// import img3 from "../../../assets/img3.jpg";
import Footer from '../../../general/footer/Footer';
import { Link } from 'react-router-dom';
import a3 from "../../../assets/a3.jpg";


const Family = () => {
  return (
    <div>
      <div className="insurance-section">
        <div className="insurance-content">
          <div className="breadcrumb">
            <span>Home</span> &nbsp;•&nbsp;
            <span>Ous Services</span> &nbsp;•&nbsp;
            <span className="active">Family Office Services </span>
          </div>
          <h1>Family Office Services </h1>
          <p>
            At PSJ Capital Ventures, we empower HNIs, UHNIs, business families, and new-age wealth creators to structure and manage their wealth like institutional investors - through a comprehensive Family Office approach.
          </p>
        </div>
        <div className="insurance-image">
          <img src={a3} alt="Insurance Family" />
        </div>
      </div>

      <div className="travel-details-container">
        {/* LEFT SECTION */}
        <div className="travel-details-left">
          <h2>What Is a Family Office?</h2>
          <p>
            A Family Office is a centralized structure to manage, preserve, and grow family wealth across generations. It combines investment management, tax planning, succession, philanthropy, risk management, and lifestyle services under a single umbrella — tailored to the unique needs of a family.

          </p>
          {/* <h3 style={{color:'black'}}>Why Mutual Funds Matter</h3>
                    <p className="bold-line">
                        Mutual funds remain one of the most versatile and trusted investment avenues for building long-term wealth. Whether you're a first-time investor or a seasoned professional, mutual funds offer an accessible, professionally managed way to diversify across asset classes, geographies, and strategies - all within a regulated and transparent structure.<br></br>
                        <br></br>At PSJ Capital Ventures, we curate mutual fund portfolios tailored to your financial goals, risk appetite, and time horizon - backed by in-depth research and ongoing reviews.
                    </p> */}

          <h3 style={{ color: 'black' }}>There are two primary types</h3>
          <div className="plan-columns">

            <div className='key-terminologies'>
              <h5>1.	Single-Family Office (SFO): </h5>
              <p>Built exclusively for one ultra-wealthy family.
              </p>
              <h5>2. 		Multi-Family Office (MFO):  </h5>
              <p>A shared platform for multiple families with aligned interests and scalable costs.</p>
            </div>
            {/* <div className='key-terminologies'>
                            <h5>3. 	Alpha </h5>
                            <p>Excess return generated over the benchmark.</p>
                            <h5>4. 	Drawdown </h5>
                            <p>Peak-to-trough decline in portfolio value.</p>
                        </div> */}
          </div>

          {/* Service Benefits */}
          <div className="benefits-section">
            <div className="benefits-image">
              <img src={img2} alt="Service Benefits" />
            </div>
            <div className="benefits-list">
              <h4> Why Choose PSJ for Family Office Services?</h4>
              {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
              <ul>
                <li>✓ 		Boutique, Confidential & Relationship-Driven  </li>
                <li>✓ 		Cross-Domain Expertise </li>
                <li>✓ 		Full-Spectrum Advisory  </li>
                <li> ✓		Seamless Coordination  </li>
                <li> ✓  	Institutional-Grade Research  </li>
              </ul>
            </div>
          </div>

          {/* More Benefits */}
          <div className="service-benefits">
            <h3>Services We Offer</h3>

            <ul>
              <li>✓ 	Investment Management</li>
              <li>✓ 	Tax & Compliance Support</li>
              <li>✓ 		Wealth Structuring & Estate Planning</li>
              <li>✓ 		Philanthropy & Impact Advisory</li>
              <li>✓ 		Treasury & Liquidity Management</li>
              <li>✓  Family Governance</li>
            </ul>
            <h3>Who Do We Work With?</h3>

            <ul>
              <li>	First-gen entrepreneurs with new wealth</li>
              <li>	Traditional business families institutionalizing wealth</li>
              <li>	Angel investors & startup founders</li>
              <li>	NRI families with India-based assets</li>
              <li>	Real estate developers seeking diversification</li>
              <li>	Corporate treasuries of promoter-led firms</li>
            </ul>
            <p>
              Let’s Build Your Legacy, Together
              If you’re looking to bring order to your financial chaos, create a structure that survives you, and preserve wealth across generations — a Family Office model is your best next step.

              Schedule a private session with our Family Office Desk to explore how PSJ Capital Ventures can serve as your trusted steward in India and globally.



            </p>
          </div>
          <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
        </div>

        {/* RIGHT SECTION */}
        <div className="travel-details-right">
          <div className="services-box">
            <h4>Our Services</h4>
            <ul>
              <Link to='/mutual-funds'><li>Mutual Funds →</li></Link>
              <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
              <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
              <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
              <Link to='/nri-corner'><li>NRI Corner →</li></Link>
              <Link to='/insurance'><li>Insurance →</li></Link>
              <Link to='/loan-syndication'><li>Loan Syndication →</li></Link>
              <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
              <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
              <Link to='/stock-broking'><li>Stock Broking →</li></Link>
            </ul>
          </div>

          <div className="advisor-box">
            <img src={client2} alt="Advisor" />
            <p>Make your dream life get professional help</p>
            <div className="contact-info">
              <span>📞 CONTACT US</span>
              <p>+91 8108 430 942</p>
            </div>
          </div>
        </div>
      </div>
      <br></br><br></br><br></br>
      <Footer />
    </div>
  )
}

export default Family


